export const COMMUNITY_COMMENT_INPUT_ID = 'community_comment_input_id';

export const COMMUNITY_POST_TYPES = {
  post: 'post',
  marketplace: 'marketplace',
  recommendation: 'recommendation',
};

export const AVOID_STATUSES = 'declined';

export const COMMUNITY_IMAGES_LIMIT = 4;
